<template>
    <div class="shop__myclimate shop__options-block">
        <div class="shop__options-block-input">
            <MyClimateCheckbox v-model="wantsMyClimate" />
        </div>
        <div class="shop__options-block-desc">
            <MyClimateDescription />
        </div>
    </div>
</template>

<script>
    import Transaction from '@/models/Transaction'

    export default {
        computed: {
            CurrentTransaction() {
                return Transaction.query().first();
            },
            wantsMyClimate: {
                get() { return this.CurrentTransaction.myClimate; },
                set(val) { this.CurrentTransaction.$update({ myClimate: val }); }
            }
        }
    };
</script>